module.exports = "/images/lena-3.webp?7f64ab528d827b5e2d60e222d58da984";